import {RateLimitExceeded} from "@/api/api.service.ts";

type PromiseFn<T> = () => Promise<T>

export function useRateLimitHandler<T>(fn: PromiseFn<T>): PromiseFn<void | T> {
  return () => fn().catch(catchRateLimitExceeded)
}

export function catchRateLimitExceeded(error: unknown) {
  if (error instanceof RateLimitExceeded) {
    handleRateLimitExceeded(error)
  }
}

export function handleRateLimitExceeded(error: RateLimitExceeded) {
  console.log("rate limit exceeded ->", error)
  const modal = document.getElementById('accessModal') as HTMLModalElement
  modal.showModal()
}

// See "src/main/resources/templates/fragments/access_overlay.peb"
interface HTMLModalElement extends HTMLElement {
  showModal(): void

  hideModal(): void
}
